import {DetailTable} from '../../mapping-classes/detail-table';

export class Linkids implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(detailsViewObject: any) {
    if (!detailsViewObject || !detailsViewObject.linkIds || detailsViewObject.linkIds.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = detailsViewObject.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(detailsViewObject.linkIds);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen koppelcodes gevonden.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'id',
      'description',
      'amount',
    ];
  }

  setRowData(linkIds) {
    linkIds.forEach((linkId) => {
      if (this.restrictedData) {
        linkId.amount = this.shieldedText;
      }
      this.rowData.push(linkId);
    });
  }
}
